import React from 'react';
import { Select } from '@/components/ui';
import useLadyService from '@/services/LadyService';
import { useSelector } from 'react-redux';
import {
	getCountriesData,
	getUserCurrentDistrict,
} from '@/stores/slices/userSlice';
import { getValidDistrictSlug } from '@/helper/linkCitySlug';

const DropdownLanguage = ({ size = 'xs' }) => {
	const { city } = useLadyService();
	const currentDistrict = useSelector(getUserCurrentDistrict);
	const countriesData = useSelector(getCountriesData);
	const districtSlug = getValidDistrictSlug(
		city,
		currentDistrict,
		countriesData,
	);
	const isJsdom =
		typeof window !== 'undefined' &&
		window.navigator.userAgent.includes('jsdom');
		
	const languages = [
		{
			id: 1,
			link:
				city === 'czechia'
					? '/'
					: districtSlug
						? `/en/${city}_${districtSlug}`
						: `/en/${city}`,
			title: 'EN',
			value: 'en',
		},

		{
			id: 3,
			link:
				districtSlug
					? `/cz/${city}_${districtSlug}`
					: `/cz/${city}`,
			title: 'CZ',
			value: 'cz',
		},

		{
			id: 2,
			link:
				districtSlug
					? `/ru/${city}_${districtSlug}`
					: `/ru/${city}`,
			title: 'RU',
			value: 'ru',
		},

		{
		    id: 5,
		    link:
		        districtSlug
		            ? `/sk/${city}_${districtSlug}`
		            : `/sk/${city}`,
		    title: 'SK',
		    value: 'sk',
		},
		
		{
		    id: 4,
		    link:
		        districtSlug
		            ? `/de/${city}_${districtSlug}`
		            : `/de/${city}`,
		    title: 'DE',
		    value: 'de',
		},

		
	];
	if (!isJsdom) {
		return (
			<Select
				options={languages}
				size={size}
				arrowSize={'s'}
				sorted={true}
				name={'language'}
			></Select>
		);
	} else {
		return languages.map((link) => {
			return (
				<a
					href={link.link}
					key={'link-' + link.title}
				>
					{link.title}
				</a>
			);
		});
	}
};

export default DropdownLanguage;
